import { useQueryClient } from "@tanstack/react-query";
import { ErrorBoundary } from "react-error-boundary";

import { useTranslate } from "@similarweb/i18n-provider";

import { SIBreadcrumbs } from "app/pages/sales-intelligence/common-components/SIBreadcrumbs/SIBreadcrumbs";
import { SignalRecommenderContainer } from "app/pages/sales-intelligence/modules/signal-recommender/containers/SignalRecommenderContainer";
import { signalRecommenderQueryKeys } from "app/pages/sales-intelligence/modules/signal-recommender/query/key-factory/factory";
import ManageSignalAnalysisPage from "app/pages/sales-intelligence/pages/manage-signals/components/ManageSignalAnalysisPage/ManageSignalAnalysisPage";
import { SIGNAL_ANALYSIS_BREADCRUMBS } from "app/pages/sales-intelligence/pages/manage-signals/constants/breadcrumbs";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { PageErrorState } from "./components/ErrorState/PageErrorState";

const SignalAnalysisPageContainer = () => {
    const { translate } = useTranslate();
    const queryClient = useQueryClient();

    const breadcrumbs = SIGNAL_ANALYSIS_BREADCRUMBS.map((item) => ({ ...item, title: translate(item.title) }));

    const handleBreadcrumbClick = ({ state }: { state: string }) => {
        void proNavigator.go(state);
    };

    // A render crash here is almost always the history payload; remounting alone would re-render the
    // same cached response and throw again, so the entry is dropped and refetched on retry.
    const handleErrorBoundaryReset = () => {
        void queryClient.resetQueries({ queryKey: signalRecommenderQueryKeys.files() });
    };

    return (
        <ErrorBoundary
            FallbackComponent={PageErrorState}
            onReset={handleErrorBoundaryReset}
        >
            <SIBreadcrumbs
                dataAutomation="signal-analysis-breadcrumbs"
                list={breadcrumbs}
                onClick={handleBreadcrumbClick}
            />

            <ManageSignalAnalysisPage>
                <SignalRecommenderContainer />
            </ManageSignalAnalysisPage>
        </ErrorBoundary>
    );
};

export default SignalAnalysisPageContainer;
